export const getFileName = (src: string) => src.replace(/^.*[\\/]/, '').split('?')[0]
